export default function PolitiqueConfidentialite() {
  return (
    <div className="bg-[#FDFBF7] min-h-screen pt-16" data-testid="privacy-page">
      <section className="max-w-3xl mx-auto px-6 md:px-10 py-20">
        <span className="font-script text-2xl text-[#A61C24]">Vos données</span>
        <h1 className="font-serif text-4xl md:text-5xl text-[#1A1A1A] mt-2 mb-10">Politique de confidentialité</h1>

        <div className="space-y-8 text-[#1A1A1A]/85 leading-relaxed">
          <section>
            <h2 className="font-serif text-2xl mb-3">Collecte des données</h2>
            <p>
              Les réservations se font exclusivement par téléphone ; aucun formulaire de collecte n'est présent sur le site.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Cookies</h2>
            <p>
              Seul un stockage technique local est utilisé (sessionStorage) afin d'éviter de ré-afficher plusieurs fois nos annonces lors d'une même visite. Aucune donnée n'est transmise à des tiers à des fins publicitaires.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Contact pour une demande</h2>
            <p>
              Si vous nous avez contactés par email ou téléphone, vos coordonnées sont utilisées uniquement pour répondre à votre demande et ne sont pas conservées au-delà du nécessaire.
            </p>
            <p className="mt-3">
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ce droit, écrivez-nous à :{" "}
              <a href="mailto:bdelaneuve@gmail.com" className="text-[#A61C24] underline underline-offset-2">
                bdelaneuve@gmail.com
              </a>.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Sécurité</h2>
            <p>
              Seules les personnes autorisées (gérant &amp; équipe) ont accès à l'interface d'administration, protégée par authentification. Aucune information bancaire n'est collectée sur ce site.
            </p>
          </section>

          <section>
            <h2 className="font-serif text-2xl mb-3">Modifications</h2>
            <p>
              La présente politique peut être mise à jour à tout moment. Merci de la consulter régulièrement.
            </p>
          </section>
        </div>
      </section>
    </div>
  );
}
